import { render, staticRenderFns } from "./form-component-text.vue?vue&type=template&id=80b0d048"
import script from "./form-component-text.vue?vue&type=script&lang=ts"
export * from "./form-component-text.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports